<div class="checkable-list">
  @if (withSearch()) {
    <input
      type="text"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      placeholder="Rechercher..."
      class="checkable-list__search mb-2"
      [disabled]="!items().length" />
  }
  @if (loading()) {
    <i-loader></i-loader>
  } @else {
    @for (item of search().length ? filteredCheckableItems() : items(); track item; let last = $last) {
      <div
        class="checkable-list__element"
        [class.pb-2]="!last"
        [ngStyle]="{ backgroundColor: item.checked ? 'var(--selected-color)' : '' }"
        (click)="item.checked = !item.checked; onCheckElement(item)">
        <span class="me-2">
          <p-checkbox
            [(ngModel)]="item.checked"
            [binary]="true"
            (onChange)="$event.originalEvent.stopPropagation(); onCheckElement(item)"></p-checkbox>
        </span>
        <div class="checkable-list__element__label">
          {{ getItemLabel(item) }}
        </div>
      </div>
    } @empty {
      <div>
        @if (search().length) {
          Aucun élément correspondant à votre recherche.
        } @else {
          Aucun élément
        }
      </div>
    }
  }
</div>
